import React from 'react';
const UserManagement =()=>{
    return (
        <div>
            用户管理
        </div>
    )
}
export default UserManagement